export const linkedInURL =
  "https://www.linkedin.com/company/98386709/admin/dashboard/";
export const githubURL = "https://github.com";
export const twitterURL = "https://twitter.com/First__Land";
export const instagramURL = "https://www.instagram.com/first_land/";
export const fbURL = "https://www.facebook.com/First_Land";
export const gmailURL = "ToFistLand@gmial.com";
export const buyAndSellLink = "/Buy-Sell-or-Rent";
